module.exports = __webpack_public_path__ + "img/mq.8c1db4f3.svg";